<template>
  <div
    ref="expiredModal"
    class="modal fade custom-modal"
    id="subscription-expired-modal"
    tabindex="-1"
    aria-labelledby="subscriptionExpiredModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered modal-sm">
      <div class="modal-content popup-color">
        <div class="modal-header py-1">
          <h5 class="modal-title" id="subscriptionExpiredModalLabel">
            {{ heading }}
          </h5>
          <a
            class="btn-close custom-close-button"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></a>
        </div>
        <div class="modal-body text-center py-0">
          <p class="my-4 text-left">{{ message }}</p>
        </div>
        <div class="modal-footer d-flex justify-content-center py-1">
          <a href="#" class="btn btn-custom prime_btn" @click="handleAction">{{
            buttonText
          }}</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Modal } from "bootstrap";

export default {
  props: {
    message: {
      type: String,
      required: true,
      default:
        "Become a PrimeInvestor to track your portfolio and access our recommendations in stocks, MFs, ETFs & more",
    },
    heading: {
      type: String,
      required: true,
      default: "Subscribers only!",
    },
    buttonText: {
      type: String,
      required: true,
      default: "Subscribe Now",
    },
  },
  data() {
    return {
      planType: "",
      baseURL: process.env.VUE_APP_BASE_URL,
    };
  },
  methods: {
    showModal(planType) {
      this.planType = planType;
      const modalElement = this.$refs.expiredModal;
      const modal = new Modal(modalElement);
      modal.show();
    },
    handleAction() {
      const upgradeLink =
        this.planType === "Prime Essentials"
          ? `${this.baseURL}/my-prime/`
          : `${this.baseURL}/prime-pricing/`;
      window.open(upgradeLink, "_blank");
    },
  },
};
</script>

<style scoped>
.popup-color {
  background: linear-gradient(180deg, #ffffff 0%, rgba(31, 209, 159, 0.5) 100%);
}

.custom-modal .modal-footer {
  border-top: none;
}

.custom-close-button {
  transform: scale(0.75);
}

.btn-custom {
  background-color: #01a2d9;
  border-color: #01a2d9;
  color: white;
}

.btn-custom:hover {
  background-color: #01a2d9;
  border-color: #01a2d9;
  color: white;
}
</style>
